import get from 'lodash/get'
import { fromJS } from 'immutable'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get referral attributions for a user
 * @param {Object} options The options
 * @param {import('immutable').Map} options.auth The auth object
 * @param {String} options.uuid The user uuid
 * @param {String} options.server The server
 * @returns {Promise<import('immutable').Map>} The response body
 */
export async function getAttributions (options = {}) {
  const { auth, uuid, server } = options
  const res = await request
    .get(`${server}/v1/user/referrals/lookup?uuid[]=${uuid}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(get(res, 'body.data', []))
}
